export var CooperationType;
(function (CooperationType) {
    CooperationType[CooperationType["Undefined"] = 0] = "Undefined";
    CooperationType[CooperationType["SteeringGroupMembership"] = 1] = "SteeringGroupMembership";
    CooperationType[CooperationType["OtherExpertKnowHow"] = 2] = "OtherExpertKnowHow";
    CooperationType[CooperationType["CustomerGuidance"] = 3] = "CustomerGuidance";
    CooperationType[CooperationType["EventOrganisingCoop"] = 4] = "EventOrganisingCoop";
    CooperationType[CooperationType["CommunicationalCoop"] = 5] = "CommunicationalCoop";
    CooperationType[CooperationType["FinancialCoopAidTransfer"] = 6] = "FinancialCoopAidTransfer";
    CooperationType[CooperationType["FinancialCoopPremisesUsage"] = 7] = "FinancialCoopPremisesUsage";
    CooperationType[CooperationType["FinancialCoopEmployeeResource"] = 8] = "FinancialCoopEmployeeResource";
})(CooperationType || (CooperationType = {}));
